import { render, staticRenderFns } from "./ProcessFlowCard.vue?vue&type=template&id=3bcd9ef8&"
import script from "./ProcessFlowCard.vue?vue&type=script&lang=js&"
export * from "./ProcessFlowCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports